import { Modal } from "react-bootstrap";
import { useText } from "../../context/TextContext";
import { TimeRecord } from "../../models/shared/TimeRecord";
import TimesheetEntryForm from "../TimesheetEntryForm";

interface Props {
  onClose: () => void;
  initialData?: TimeRecord;
}


export default function TimesheetEntryModal({ onClose, initialData }: Props) {
  const text = useText();

  return (
    <Modal show={true} onHide={onClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{initialData ? text.edit : text.newTimesheetEntry}</Modal.Title>
      </Modal.Header>
      <TimesheetEntryForm onClose={onClose} initialData={initialData} modal />
    </Modal>
  );
}
